import React from 'react';
import { Ship, Truck, Factory, Tractor } from 'lucide-react';
const applications = [{
  title: 'Marine & Boating',
  icon: Ship,
  description: 'Engine cooling, bilge, freshwater, and washdown pumps for boats and yachts.'
}, {
  title: 'RV & Mobile',
  icon: Truck,
  description: 'Freshwater, water pressure, and fuel/oil transfer pumps for RVs and trailers.'
}, {
  title: 'Commercial & Industrial',
  icon: Factory,
  description: 'High-pressure water, chemical, and fuel/oil transfer for industrial systems.'
}, {
  title: 'Agricultural & Utility',
  icon: Tractor,
  description: 'Irrigation, well, and sump pumps for farms and utility applications.'
}];
export function Applications() {
  return <section className="w-full bg-slate-50 border-y border-slate-200" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-12">
        <div className="mb-6" data-id="element-13">
          <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-2" data-id="element-14">
            Pumps for Marine, RV & Industrial Applications
          </h2>
          <p className="text-slate-600 max-w-2xl" data-id="element-15">
            CLR Marine supplies pumps and replacement parts across marine, RV,
            commercial, and industrial fluid transfer systems.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-16">
          {applications.map(app => <div key={app.title} className="bg-white rounded-lg p-5 border border-slate-200 hover:border-marine-blue hover:shadow-sm transition-all duration-150" data-id="element-17">
              <div className="w-10 h-10 rounded-md bg-marine-light text-marine-blue flex items-center justify-center mb-4" data-id="element-18">
                <app.icon className="w-5 h-5" data-id="element-19" />
              </div>
              <h3 className="text-base font-semibold text-slate-900 mb-2" data-id="element-20">
                {app.title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed" data-id="element-21">
                {app.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}